/**
 * Generated. DO NOT edit directly
 */

export const color_global_brand_raw_carbon = '#191919';
export const color_global_brand_raw_slate = '#6B665F';
export const color_global_brand_raw_gravel = '#AFABA1';
export const color_global_brand_raw_sand = '#E8DCC7';
export const color_global_brand_raw_cream = '#F6F1E7';
export const color_global_brand_raw_snow = '#FEFEFA';
export const color_global_brand_raw_cobalt = '#1A31A9';
export const color_global_brand_raw_sky = '#3F59E4';
export const color_global_brand_raw_cloud = '#B6C9FF';
export const color_global_brand_raw_ocean = '#096256';
export const color_global_brand_raw_seafoam = '#4CB7A3';
export const color_global_brand_raw_turquoise = '#B1E4DE';
export const color_global_brand_raw_eggplant = '#4016A0';
export const color_global_brand_raw_violet = '#7549F2';
export const color_global_brand_raw_lilac = '#B49BFC';
export const color_global_brand_raw_forest = '#0F5C34';
export const color_global_brand_raw_emerald = '#149750';
export const color_global_brand_raw_pistachio = '#8FC88A';
export const color_global_brand_raw_clay = '#763101';
export const color_global_brand_raw_tangerine = '#E27133';
export const color_global_brand_raw_melon = '#F2AC84';
export const color_global_brand_raw_walnut = '#744E00';
export const color_global_brand_raw_goldenrod = '#EF9B05';
export const color_global_brand_raw_wheat = '#F4D594';
export const color_global_functional_static_neutral_50 = '#8E8E8E';
export const color_global_functional_static_neutral_100 = '#686868';
export const color_global_functional_static_neutral_200 = '#555555';
export const color_global_functional_static_neutral_300 = '#3E3E3E';
export const color_global_functional_static_neutral_white = '#FFFFFF';
export const color_global_functional_static_neutral_black = '#000000';
export const color_global_functional_static_blue_50 = '#7487EB';
export const color_global_functional_static_blue_100 = '#3F59E4';
export const color_global_functional_static_blue_200 = '#3449BA';
export const color_global_functional_static_blue_300 = '#263588';
export const color_global_functional_static_red_50 = '#DF6B63';
export const color_global_functional_static_red_100 = '#C32F26';
export const color_global_functional_static_red_200 = '#A0271F';
export const color_global_functional_static_red_300 = '#761C17';
export const color_global_functional_static_green_50 = '#2BA161';
export const color_global_functional_static_green_100 = '#10783F';
export const color_global_functional_static_green_200 = '#0D6234';
export const color_global_functional_static_green_300 = '#094726';
export const color_global_functional_static_yellow_50 = '#FDE981';
export const color_global_functional_static_yellow_100 = '#F8D626';
export const color_global_functional_static_yellow_200 = '#E3C423';
export const color_global_functional_static_yellow_300 = '#C5AA1F';
export const color_global_functional_static_purple_50 = '#9979F5';
export const color_global_functional_static_purple_100 = '#7146E9';
export const color_global_functional_static_purple_200 = '#5C3ABF';
export const color_global_functional_static_purple_300 = '#432A8B';
export const color_global_functional_static_magenta_50 = '#FF44DD';
export const color_global_functional_static_magenta_100 = '#C638A7';
export const color_global_functional_static_magenta_200 = '#8D2B72';
export const color_global_functional_static_magenta_300 = '#541F3C';
export const color_global_functional_dark_neutral_25 = '#111111';
export const color_global_functional_dark_neutral_50 = '#171717';
export const color_global_functional_dark_neutral_100 = '#1E1E1E';
export const color_global_functional_dark_neutral_200 = '#242424';
export const color_global_functional_dark_neutral_300 = '#2A2A2A';
export const color_global_functional_dark_neutral_400 = '#383838';
export const color_global_functional_dark_neutral_500 = '#555555';
export const color_global_functional_dark_neutral_600 = '#808080';
export const color_global_functional_dark_neutral_700 = '#ABABAB';
export const color_global_functional_dark_neutral_800 = '#C5C5C5';
export const color_global_functional_dark_neutral_900 = '#E5E5E5';
export const color_global_functional_dark_neutral_1000 = '#FBFBFB';
export const color_global_functional_dark_blue_25 = '#0B0F26';
export const color_global_functional_dark_blue_50 = '#0F1535';
export const color_global_functional_dark_blue_100 = '#131B44';
export const color_global_functional_dark_blue_200 = '#161F50';
export const color_global_functional_dark_blue_300 = '#1A245D';
export const color_global_functional_dark_blue_400 = '#22307C';
export const color_global_functional_dark_blue_500 = '#3449BA';
export const color_global_functional_dark_blue_600 = '#6177E9';
export const color_global_functional_dark_blue_700 = '#99A7F1';
export const color_global_functional_dark_blue_800 = '#B9C3F5';
export const color_global_functional_dark_blue_900 = '#E0E4FB';
export const color_global_functional_dark_blue_1000 = '#FAFBFE';
export const color_global_functional_dark_red_25 = '#230807';
export const color_global_functional_dark_red_50 = '#2F0B09';
export const color_global_functional_dark_red_100 = '#3C0F0C';
export const color_global_functional_dark_red_200 = '#46110E';
export const color_global_functional_dark_red_300 = '#521410';
export const color_global_functional_dark_red_400 = '#6B1A15';
export const color_global_functional_dark_red_500 = '#A0271F';
export const color_global_functional_dark_red_600 = '#DA534A';
export const color_global_functional_dark_red_700 = '#E89590';
export const color_global_functional_dark_red_800 = '#F0B7B4';
export const color_global_functional_dark_red_900 = '#F8E0DE';
export const color_global_functional_dark_red_1000 = '#FEFAFA';
export const color_global_functional_dark_green_25 = '#03140B';
export const color_global_functional_dark_green_50 = '#041C0F';
export const color_global_functional_dark_green_100 = '#052413';
export const color_global_functional_dark_green_200 = '#062A16';
export const color_global_functional_dark_green_300 = '#06311A';
export const color_global_functional_dark_green_400 = '#094122';
export const color_global_functional_dark_green_500 = '#0D6234';
export const color_global_functional_dark_green_600 = '#13934E';
export const color_global_functional_dark_green_700 = '#67BC8E';
export const color_global_functional_dark_green_800 = '#98D2B2';
export const color_global_functional_dark_green_900 = '#D2EBDE';
export const color_global_functional_dark_green_1000 = '#F7FCF9';
export const color_global_functional_dark_yellow_25 = '#141103';
export const color_global_functional_dark_yellow_50 = '#1B1804';
export const color_global_functional_dark_yellow_100 = '#231F05';
export const color_global_functional_dark_yellow_200 = '#292406';
export const color_global_functional_dark_yellow_300 = '#312A08';
export const color_global_functional_dark_yellow_400 = '#41380A';
export const color_global_functional_dark_yellow_500 = '#62540F';
export const color_global_functional_dark_yellow_600 = '#947F17';
export const color_global_functional_dark_yellow_700 = '#C5AA1F';
export const color_global_functional_dark_yellow_800 = '#E3C423';
export const color_global_functional_dark_yellow_900 = '#FDE66F';
export const color_global_functional_dark_yellow_1000 = '#FFFBE9';
export const color_global_functional_dark_purple_25 = '#130C28';
export const color_global_functional_dark_purple_50 = '#1A1137';
export const color_global_functional_dark_purple_100 = '#221546';
export const color_global_functional_dark_purple_200 = '#281952';
export const color_global_functional_dark_purple_300 = '#2E1D60';
export const color_global_functional_dark_purple_400 = '#3D267F';
export const color_global_functional_dark_purple_500 = '#5C3ABF';
export const color_global_functional_dark_purple_600 = '#8B66F4';
export const color_global_functional_dark_purple_700 = '#B59DF8';
export const color_global_functional_dark_purple_800 = '#CCBCFA';
export const color_global_functional_dark_purple_900 = '#E9E2FD';
export const color_global_functional_dark_purple_1000 = '#FBFAFF';
export const color_global_functional_dark_teal_25 = '#081311';
export const color_global_functional_dark_teal_50 = '#0B1A17';
export const color_global_functional_dark_teal_100 = '#0E221E';
export const color_global_functional_dark_teal_200 = '#102823';
export const color_global_functional_dark_teal_300 = '#132F29';
export const color_global_functional_dark_teal_400 = '#1A3E37';
export const color_global_functional_dark_teal_500 = '#275E53';
export const color_global_functional_dark_teal_600 = '#3B8D7E';
export const color_global_functional_dark_teal_700 = '#58BCA9';
export const color_global_functional_dark_teal_800 = '#8ED2C5';
export const color_global_functional_dark_teal_900 = '#CEEBE6';
export const color_global_functional_dark_teal_1000 = '#F7FCFB';
export const color_global_functional_dark_orange_25 = '#1B0E06';
export const color_global_functional_dark_orange_50 = '#261309';
export const color_global_functional_dark_orange_100 = '#31180B';
export const color_global_functional_dark_orange_200 = '#391C0D';
export const color_global_functional_dark_orange_300 = '#42210F';
export const color_global_functional_dark_orange_400 = '#582C14';
export const color_global_functional_dark_orange_500 = '#85421E';
export const color_global_functional_dark_orange_600 = '#C8642D';
export const color_global_functional_dark_orange_700 = '#EA976A';
export const color_global_functional_dark_orange_800 = '#F1B99B';
export const color_global_functional_dark_orange_900 = '#F9E1D3';
export const color_global_functional_dark_orange_1000 = '#FEFAF8';
export const color_global_functional_dark_gold_25 = '#181001';
export const color_global_functional_dark_gold_50 = '#211601';
export const color_global_functional_dark_gold_100 = '#2B1C01';
export const color_global_functional_dark_gold_200 = '#322001';
export const color_global_functional_dark_gold_300 = '#3B2601';
export const color_global_functional_dark_gold_400 = '#4E3302';
export const color_global_functional_dark_gold_500 = '#754C02';
export const color_global_functional_dark_gold_600 = '#B17304';
export const color_global_functional_dark_gold_700 = '#EC9905';
export const color_global_functional_dark_gold_800 = '#F4BC57';
export const color_global_functional_dark_gold_900 = '#FAE2B8';
export const color_global_functional_dark_gold_1000 = '#FEFAF3';
export const color_global_functional_dark_magenta_50 = '#541F3C';
export const color_global_functional_dark_magenta_100 = '#541F3C';
export const color_global_functional_dark_magenta_200 = '#541F3C';
export const color_global_functional_dark_magenta_300 = '#8D2B72';
export const color_global_functional_dark_magenta_400 = '#C638A7';
export const color_global_functional_dark_magenta_500 = '#FF44DD';
export const color_global_functional_dark_magenta_600 = '#FF79E7';
export const color_global_functional_dark_magenta_700 = '#FFAFF0';
export const color_global_functional_dark_magenta_800 = '#FFE4FA';
export const color_global_functional_dark_magenta_900 = '#FFE4FA';
export const color_global_functional_dark_magenta_1000 = '#FFE4FA';
export const color_global_functional_light_neutral_50 = '#FBFBFB';
export const color_global_functional_light_neutral_100 = '#F6F6F6';
export const color_global_functional_light_neutral_200 = '#F1F1F1';
export const color_global_functional_light_neutral_300 = '#E8E8E8';
export const color_global_functional_light_neutral_400 = '#D7D7D7';
export const color_global_functional_light_neutral_500 = '#B9B9B9';
export const color_global_functional_light_neutral_600 = '#8E8E8E';
export const color_global_functional_light_neutral_700 = '#686868';
export const color_global_functional_light_neutral_800 = '#555555';
export const color_global_functional_light_neutral_900 = '#3E3E3E';
export const color_global_functional_light_neutral_1000 = '#191919';
export const color_global_functional_light_blue_50 = '#FAFBFE';
export const color_global_functional_light_blue_100 = '#F5F6FE';
export const color_global_functional_light_blue_200 = '#EEF0FD';
export const color_global_functional_light_blue_300 = '#E4E7FB';
export const color_global_functional_light_blue_400 = '#CFD6F8';
export const color_global_functional_light_blue_500 = '#AAB6F3';
export const color_global_functional_light_blue_600 = '#7487EB';
export const color_global_functional_light_blue_700 = '#3F59E4';
export const color_global_functional_light_blue_800 = '#3449BA';
export const color_global_functional_light_blue_900 = '#263588';
export const color_global_functional_light_blue_1000 = '#10163A';
export const color_global_functional_light_green_50 = '#F7FCF9';
export const color_global_functional_light_green_100 = '#F0F8F4';
export const color_global_functional_light_green_200 = '#E6F4EC';
export const color_global_functional_light_green_300 = '#D7EDE1';
export const color_global_functional_light_green_400 = '#B9E0CB';
export const color_global_functional_light_green_500 = '#81C7A1';
export const color_global_functional_light_green_600 = '#2BA161';
export const color_global_functional_light_green_700 = '#10783F';
export const color_global_functional_light_green_800 = '#0D6234';
export const color_global_functional_light_green_900 = '#094726';
export const color_global_functional_light_green_1000 = '#041E10';
export const color_global_functional_light_red_50 = '#FEFAFA';
export const color_global_functional_light_red_100 = '#FDF5F4';
export const color_global_functional_light_red_200 = '#FBEEED';
export const color_global_functional_light_red_300 = '#F9E3E2';
export const color_global_functional_light_red_400 = '#F5CECC';
export const color_global_functional_light_red_500 = '#ECA7A3';
export const color_global_functional_light_red_600 = '#DF6B63';
export const color_global_functional_light_red_700 = '#C32F26';
export const color_global_functional_light_red_800 = '#A0271F';
export const color_global_functional_light_red_900 = '#761C17';
export const color_global_functional_light_red_1000 = '#330C0A';
export const color_global_functional_light_yellow_50 = '#FFFBE9';
export const color_global_functional_light_yellow_100 = '#FEF7D3';
export const color_global_functional_light_yellow_200 = '#FEF2B3';
export const color_global_functional_light_yellow_300 = '#FDE981';
export const color_global_functional_light_yellow_400 = '#F8D626';
export const color_global_functional_light_yellow_500 = '#D5B721';
export const color_global_functional_light_yellow_600 = '#A48D19';
export const color_global_functional_light_yellow_700 = '#786713';
export const color_global_functional_light_yellow_800 = '#62540F';
export const color_global_functional_light_yellow_900 = '#473D0B';
export const color_global_functional_light_yellow_1000 = '#1E1A05';
export const color_global_functional_light_purple_50 = '#FBFAFF';
export const color_global_functional_light_purple_100 = '#F8F5FE';
export const color_global_functional_light_purple_200 = '#F3EFFE';
export const color_global_functional_light_purple_300 = '#EBE5FD';
export const color_global_functional_light_purple_400 = '#DCD1FC';
export const color_global_functional_light_purple_500 = '#C1ADF9';
export const color_global_functional_light_purple_600 = '#9979F5';
export const color_global_functional_light_purple_700 = '#7146E9';
export const color_global_functional_light_purple_800 = '#5C3ABF';
export const color_global_functional_light_purple_900 = '#432A8B';
export const color_global_functional_light_purple_1000 = '#1D123B';
export const color_global_functional_light_teal_50 = '#F7FCFB';
export const color_global_functional_light_teal_100 = '#EFF8F7';
export const color_global_functional_light_teal_200 = '#E4F4F1';
export const color_global_functional_light_teal_300 = '#D4EEE9';
export const color_global_functional_light_teal_400 = '#B3E0D8';
export const color_global_functional_light_teal_500 = '#75C7B8';
export const color_global_functional_light_teal_600 = '#419D8C';
export const color_global_functional_light_teal_700 = '#307366';
export const color_global_functional_light_teal_800 = '#275E53';
export const color_global_functional_light_teal_900 = '#1C443D';
export const color_global_functional_light_teal_1000 = '#0C1C19';
export const color_global_functional_light_orange_50 = '#FEFAF8';
export const color_global_functional_light_orange_100 = '#FDF5F1';
export const color_global_functional_light_orange_200 = '#FCEEE7';
export const color_global_functional_light_orange_300 = '#F9E4D8';
export const color_global_functional_light_orange_400 = '#F5D0BB';
export const color_global_functional_light_orange_500 = '#EEA984';
export const color_global_functional_light_orange_600 = '#DE6F32';
export const color_global_functional_light_orange_700 = '#A35125';
export const color_global_functional_light_orange_800 = '#85421E';
export const color_global_functional_light_orange_900 = '#613016';
export const color_global_functional_light_orange_1000 = '#291409';
export const color_global_functional_light_gold_50 = '#FEFAF3';
export const color_global_functional_light_gold_100 = '#FDF6E7';
export const color_global_functional_light_gold_200 = '#FCEFD8';
export const color_global_functional_light_gold_300 = '#FBE6C0';
export const color_global_functional_light_gold_400 = '#F8D28F';
export const color_global_functional_light_gold_500 = '#F2AB2E';
export const color_global_functional_light_gold_600 = '#C47F04';
export const color_global_functional_light_gold_700 = '#905D03';
export const color_global_functional_light_gold_800 = '#754C02';
export const color_global_functional_light_gold_900 = '#563802';
export const color_global_functional_light_gold_1000 = '#241701';
export const color_global_functional_light_magenta_50 = '#FFE4FA';
export const color_global_functional_light_magenta_100 = '#FFE4FA';
export const color_global_functional_light_magenta_200 = '#FFE4FA';
export const color_global_functional_light_magenta_300 = '#FFAFF0';
export const color_global_functional_light_magenta_400 = '#FF79E7';
export const color_global_functional_light_magenta_500 = '#FF44DD';
export const color_global_functional_light_magenta_600 = '#C638A7';
export const color_global_functional_light_magenta_700 = '#8D2B72';
export const color_global_functional_light_magenta_800 = '#541F3C';
export const color_global_functional_light_magenta_900 = '#541F3C';
export const color_global_functional_light_magenta_1000 = '#541F3C';
export const color_elevation_default = 'rgba(0, 0, 0, 0.1)'; // Default shadow color for elevations.
export const color_elevation_bold = 'rgba(0, 0, 0, 0.18)'; // A more prominent version of Default.
export const color_chart_categorical_1 = '#3F59E4'; // Use for data visualization. Step 1 of 6.
export const color_chart_categorical_2 = '#CCBCFA'; // Use for data visualization. Step 2 of 6.
export const color_chart_categorical_3 = '#F1B99B'; // Use for data visualization. Step 3 of 6.
export const color_chart_categorical_4 = '#FEFAF8'; // Use for data visualization. Step 4 of 6.
export const color_chart_categorical_5 = '#3B8D7E'; // Use for data visualization. Step 5 of 6.
export const color_chart_categorical_6 = '#7487EB'; // Use for data visualization. Step 6 of 6.
export const color_chart_sequential_1 = '#3F59E4'; // An alternate option for data visualization. Step 1 of 4.
export const color_chart_sequential_2 = '#7487EB'; // An alternate option for data visualization. Step 2 of 4.
export const color_chart_sequential_3 = '#FAFBFE'; // An alternate option for data visualization. Step 3 of 4.
export const color_chart_sequential_4 = '#B9C3F5'; // An alternate option for data visualization. Step 4 of 4.
export const color_border_default = '#2A2A2A'; // Use for dividers and page-level UI elements such as sidebars and page headers. ⚠️ Not an accessible border — do not use for inputs.
export const color_border_bold = '#383838'; // Use for UI components that require a more-prominent border. ⚠️ Not an accessible border — do not use for inputs.
export const color_border_inverse_static = '#686868'; // Use on high-contrast backgrounds that share the same color value across all themes.
export const color_border_brand_primary = '#99A7F1'; // Use to highlight branded elements on a page or for labels.
export const color_border_brand_primary_subtle = '#22307C'; // A less prominent version of Brand Primary.
export const color_border_focus = '#22307C'; // Default focus color for all interactive elements.
export const color_border_focus_bold = '#99A7F1'; // A more prominent version of Focus.
export const color_border_focus_state_danger = '#6B1A15'; // A danger version of Focus.
export const color_border_focus_inverse_static = 'rgba(255, 255, 255, 0.4)'; // Default focus color for all Inverse Static elements that sit on high contrast backgrounds or images.
export const color_border_selected = '#99A7F1'; // Use for selected UI components.
export const color_border_disabled = '#383838'; // Use for disabled UI components.
export const color_border_disabled_selected = '#808080'; // Use for selected UI components that are disabled.
export const color_border_button = '#383838'; // Border color for the default Button.
export const color_border_input = '#808080'; // Accessible border color for inputs.
export const color_border_input_hover = '#ABABAB'; // Hover state for Input.
export const color_border_input_disabled = '#383838'; // Disabled border color for inputs.
export const color_border_state_neutral = '#ABABAB'; // Use for neutral states.
export const color_border_state_info = '#99A7F1'; // Use for info states.
export const color_border_state_success = '#67BC8E'; // Use for success states.
export const color_border_state_caution = '#C5AA1F'; // Use for caution or warning states.
export const color_border_state_danger = '#E89590'; // Use for danger or error states.
export const color_bg_page = '#111111'; // Default color for page background.
export const color_bg_layer = '#111111'; // Default color for the majority of UI components.
export const color_bg_layer_bold = '#383838'; // A more prominent version of Layer.
export const color_bg_layer_boldest = '#FBFBFB'; // The most prominent version of Layer and is typically used for tooltips or contrasting backgrounds.
export const color_bg_layer_alternate = '#1E1E1E'; // An alternate color of Layer and is typically used to establish contrast between UI elements.
export const color_bg_layer_alternate_bold = '#242424'; // A more prominent version of Layer Alternate.
export const color_bg_layer_elevated = '#171717'; // Default color for elevated UI layers such as modals or dialogs.
export const color_bg_brand_primary = '#3F59E4'; // Use to highlight branded content on a page, or for labels, badges, and avatars.
export const color_bg_brand_primary_subtle = '#161F50'; // A less prominent version of Brand Primary Subtle.
export const color_bg_backdrop = 'rgba(36, 36, 36, 0.75)'; // Default color for the layer that goes behind dialogs to narrow the user’s focus.
export const color_bg_interactive = '#111111'; // User for interactive layers or components on a page.
export const color_bg_interactive_hover = '#1E1E1E'; // Hover state for Interactive.
export const color_bg_interactive_pressed = '#242424'; // Pressed state for Interactive.
export const color_bg_disabled = '#242424'; // Use for disabled backgrounds.
export const color_bg_disabled_subtle = '#1E1E1E'; // A less prominent version of Disabled and is typically used on top of Disabled for some UI controls, such as a Switch knob.
export const color_bg_disabled_bold = '#2A2A2A'; // A more prominent version of Disabled and is typically used for smaller UI components such as Switch.
export const color_bg_selected = '#99A7F1'; // Use for selected states that don’t span a large surface.
export const color_bg_selected_hover = '#B9C3F5'; // Hover state for Selected.
export const color_bg_selected_pressed = '#E0E4FB'; // Pressed state for Selected.
export const color_bg_selected_subtle = '#161F50'; // A less prominent version of Selected and can be used for selected backgrounds that span a larger surface, or to complement a Selected border in smaller components.
export const color_bg_selected_subtle_hover = '#1A245D'; // Hover state for Selected Subtle.
export const color_bg_selected_subtle_pressed = '#22307C'; // Pressed state for Selected Subtle.
export const color_bg_state_neutral = '#686868'; // Default neutral state background color. Typically used as an accent color and can complement State Neutral Subtle in alerts.
export const color_bg_state_info = '#3F59E4'; // Default info background color. Typically used as an accent color and can complement State Info Subtle in alerts.
export const color_bg_state_success = '#10783F'; // Default success background color. Typically used as an accent color and can complement State Success Subtle in alerts.
export const color_bg_state_caution = '#F8D626'; // Default caution or warning background color. Typically used as an accent color and can complement State Caution Subtle in alerts.
export const color_bg_state_danger = '#C32F26'; // Default danger or error background color. Typically used as an accent color and can complement State Danger Subtle in alerts.
export const color_bg_state_neutral_subtle = '#242424'; // A less prominent version of State Neutral and can be used in layers that span a larger surface.
export const color_bg_state_info_subtle = '#161F50'; // A less prominent version of State Info and can be used in layers that span a larger surface.
export const color_bg_state_success_subtle = '#062A16'; // A less prominent version of State Success and can be used in layers that span a larger surface.
export const color_bg_state_caution_subtle = '#292406'; // A less prominent version of State Caution and can be used in layers that span a larger surface.
export const color_bg_state_danger_subtle = '#46110E'; // A less prominent version of State Danger and can be used in layers that span a larger surface.
export const color_bg_button = '#111111'; // Default Button background color.
export const color_bg_button_hover = '#242424'; // Hover state for Button.
export const color_bg_button_pressed = '#2A2A2A'; // Pressed state for Button.
export const color_bg_button_primary = '#3F59E4'; // Default Primary Button background color.
export const color_bg_button_primary_hover = '#3449BA'; // Hover state for Button Primary.
export const color_bg_button_primary_pressed = '#263588'; // Pressed state for Button Primary.
export const color_bg_button_danger = '#C32F26'; // Default Danger Button background color.
export const color_bg_button_danger_hover = '#A0271F'; // Hover state for Button Danger.
export const color_bg_button_danger_pressed = '#761C17'; // Pressed state for Button Danger.
export const color_bg_button_inverse_static = '#FFFFFF'; // Use on high contrast backgrounds or images.
export const color_bg_button_inverse_static_hover = '#FFFFFF'; // Hover state for Button Inverse Static.
export const color_bg_button_inverse_static_pressed = '#FFFFFF'; // Pressed state for Button Inverse.
export const color_bg_button_disabled = '#2A2A2A'; // Default Disabled Button background color.
export const color_bg_link_hover = '#242424'; // Hover state for default links.
export const color_bg_link_pressed = '#2A2A2A'; // Pressed state for default links.
export const color_bg_link_primary_hover = '#161F50'; // Hover state for primary links.
export const color_bg_link_primary_pressed = '#1A245D'; // Pressed state for primary links.
export const color_bg_link_danger_hover = '#46110E'; // Hover state for danger links.
export const color_bg_link_danger_pressed = '#521410'; // Pressed state for danger links.
export const color_bg_link_inverse_static_hover = 'rgba(255, 255, 255, 0.15)'; // Hover state for inverse links that are used on high contrast backgrounds or images.
export const color_bg_link_inverse_static_pressed = 'rgba(255, 255, 255, 0.25)'; // Pressed state for inverse links that are used on high contrast backgrounds or images.
export const color_bg_input = '#111111'; // Use for input components or form elements.
export const color_bg_input_disabled = '#242424'; // Use for disabled input components or form elements.
export const color_bg_input_disabled_bold = '#383838'; // Use for disabled input components or form elements that are smaller in size and require higher contrast to improve their legibility.
export const color_bg_app_bar = '#171717'; // Default background for the App Bar component.
export const color_bg_switch_on = '#13934E'; // Use for the on state in the Switch component.
export const color_bg_switch_on_disabled = '#094122'; // Use for the disabled on state in the Switch component.
export const color_fg_default = '#ABABAB'; // Use for body content, such as paragraphs or data display.
export const color_fg_bold = '#FBFBFB'; // Use for headings or prominent body content.
export const color_fg_brand_primary = '#99A7F1'; // Use to highlight branded content on a page, or for labels, badges, and avatars.
export const color_fg_brand_primary_subtle = '#3449BA'; // Use to highlight branded content on a page subtly where legibility isn’t a requirement.
export const color_fg_disabled = '#808080'; // Use for disabled text.
export const color_fg_decorative = '#555555'; // Use for decorative elements only as it doesn't provide enough contrast against most backgrounds.
export const color_fg_selected = '#99A7F1'; // Use for selected text.
export const color_fg_selected_disabled = '#3449BA'; // Use for selected disabled text.
export const color_fg_inverse = '#111111'; // Use on high contrast backgrounds or images.
export const color_fg_inverse_subtle = 'rgba(17, 17, 17, 0.85)'; // A less prominent version of Inverse.
export const color_fg_inverse_disabled = 'rgba(17, 17, 17, 0.5)'; // A disabled version of Inverse.
export const color_fg_inverse_static = '#FFFFFF'; // Use on high contrast backgrounds that remain the same across all themes.
export const color_fg_inverse_static_subtle = 'rgba(255, 255, 255, 0.85)'; // A less prominent version of Inverse Static.
export const color_fg_inverse_static_disabled = 'rgba(255, 255, 255, 0.5)'; // A disabled version of Inverse Static.
export const color_fg_link_primary = '#99A7F1'; // Use to highlight links within paragraphs or actions that require a high level of prominence on a page.
export const color_fg_link_primary_hover = '#B9C3F5'; // Hover state for Link Primary.
export const color_fg_link_primary_pressed = '#E0E4FB'; // Pressed state for Link Primary.
export const color_fg_link = '#FBFBFB'; // Default link color for actions that are clearly defined on a page and don’t require a high level of prominence.
export const color_fg_link_hover = '#FBFBFB'; // Hover state for Link.
export const color_fg_link_pressed = '#FBFBFB'; // Pressed state for Link.
export const color_fg_link_subtle = '#ABABAB'; // A less prominent version of Link for less prominent actions on a page.
export const color_fg_link_subtle_hover = '#C5C5C5'; // Hover state for Link Subtle.
export const color_fg_link_subtle_pressed = '#E5E5E5'; // Pressed state for Link Subtle.
export const color_fg_link_danger = '#E89590'; // Use for destructive actions or links such as delete.
export const color_fg_link_danger_hover = '#F0B7B4'; // Hover state for Link Danger.
export const color_fg_link_danger_pressed = '#F8E0DE'; // Pressed state for Link Danger.
export const color_fg_input_placeholder = '#808080'; // Default color for input placeholder text.
export const color_fg_state_neutral = '#ABABAB'; // Use for neutral state text.
export const color_fg_state_info = '#99A7F1'; // Use for info text.
export const color_fg_state_success = '#67BC8E'; // Use for success text.
export const color_fg_state_caution = '#C5AA1F'; // Use for caution or warning text.
export const color_fg_state_danger = '#E89590'; // Use for danger or error text.
export const color_fg_on_brand_primary = '#FFFFFF'; // Use for text that goes on Brand Primary backgrounds.
export const color_fg_on_brand_primary_subtle = '#B9C3F5'; // Use for text that goes on Brand Primary Subtle backgrounds.
export const color_fg_on_state_neutral = '#FFFFFF'; // Use for text that goes on State Neutral backgrounds.
export const color_fg_on_state_neutral_subtle = '#C5C5C5'; // Use for text that goes on State Neutral Subtle backgrounds.
export const color_fg_on_state_info = '#FFFFFF'; // Use for text that goes on State Info backgrounds.
export const color_fg_on_state_info_subtle = '#B9C3F5'; // Use for text that goes on State Info Subtle backgrounds.
export const color_fg_on_state_success = '#FFFFFF'; // Use for text that goes on State Success backgrounds.
export const color_fg_on_state_success_subtle = '#98D2B2'; // Use for text that goes on State Success Subtle backgrounds.
export const color_fg_on_state_caution = '#000000'; // Use for text that goes on State Caution backgrounds.
export const color_fg_on_state_caution_subtle = '#E3C423'; // Use for text that goes on State Caution Subtle backgrounds.
export const color_fg_on_state_danger = '#FFFFFF'; // Use for text that goes on State Danger backgrounds.
export const color_fg_on_state_danger_subtle = '#F0B7B4'; // Use for text that goes on State Danger Subtle backgrounds.
export const color_fg_on_button = '#FBFBFB'; // Use for text that goes on Button background.
export const color_fg_on_button_primary = '#FFFFFF'; // Use for text that goes on Button Primary background.
export const color_fg_on_button_danger = '#FFFFFF'; // Use for text that goes on Button Danger background.
export const color_fg_on_button_inverse_static = '#000000'; // Use for text that goes on Button Inverse Static background.
export const color_fg_on_button_disabled = '#808080'; // Use for text that goes on Button Disabled backgrounds.
export const color_fg_identicon = '#ABABAB'; // Default color for an identicon.
export const color_fg_identicon_subtle = '#555555'; // A lighter accent for an identicon.
export const color_fg_identicon_subtlest = '#383838'; // The lightest accent for an identicon.
export const color_fg_identicon_highlight = '#99A7F1'; // Default highlight color for an identicon.
export const color_fg_identicon_highlight_subtle = '#3449BA'; // A lighter highlight accent for an identicon.
export const color_fg_identicon_highlight_subtlest = '#22307C'; // The lightest highlight accent for an identicon.
export const type_global_monospace_10 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0.02em',
};
export const type_global_monospace_25 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_monospace_50 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0.02em',
};
export const type_global_monospace_75 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0.02em',
};
export const type_global_monospace_100 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_monospace_200 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0.02em',
};
export const type_global_monospace_300 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0.02em',
};
export const type_global_monospace_400 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_monospace_500 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0.02em',
};
export const type_global_monospace_600 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0.02em',
};
export const type_global_monospace_700 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_monospace_800 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0.02em',
};
export const type_global_monospace_900 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0.02em',
};
export const type_global_monospace_1000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0.02em',
};
export const type_global_monospace_2000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0.02em',
};
export const type_global_monospace_3000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_monospace_4000 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0.02em',
};
export const type_global_monospace_25_alt = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_monospace_75_alt = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0.02em',
};
export const type_global_secondary_10 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0em',
};
export const type_global_secondary_25 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_secondary_50 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
};
export const type_global_secondary_75 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0em',
};
export const type_global_secondary_100 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_secondary_200 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
};
export const type_global_secondary_300 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
};
export const type_global_secondary_400 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0em',
};
export const type_global_secondary_500 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0em',
};
export const type_global_secondary_600 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0em',
};
export const type_global_secondary_700 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_secondary_800 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0em',
};
export const type_global_secondary_900 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0em',
};
export const type_global_secondary_1000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0em',
};
export const type_global_secondary_2000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0em',
};
export const type_global_secondary_3000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0em',
};
export const type_global_secondary_4000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0em',
};
export const type_global_secondary_25_alt = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
};
export const type_global_secondary_75_alt = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
};
export const type_global_primary_10 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0.02em',
};
export const type_global_primary_25 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_primary_50 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0.02em',
};
export const type_global_primary_75 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.42857',
  letterSpacing: '0.02em',
};
export const type_global_primary_100 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_primary_200 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0.02em',
};
export const type_global_primary_300 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0.02em',
};
export const type_global_primary_400 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
};
export const type_global_primary_500 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.75rem',
  lineHeight: '1.28571',
  letterSpacing: '0.02em',
};
export const type_global_primary_600 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0.02em',
};
export const type_global_primary_700 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_primary_800 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0.02em',
};
export const type_global_primary_900 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0.02em',
};
export const type_global_primary_1000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0.02em',
};
export const type_global_primary_2000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0.02em',
};
export const type_global_primary_3000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
};
export const type_global_primary_4000 = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0.02em',
};
export const type_global_primary_25_alt = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
};
export const type_global_primary_75_alt = {
  fontVariantNumeric: 'slashed-zero',
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0.02em',
};
export const type_code_50 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Smallest size for code blocks or editors.
export const type_code_100 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Default size for code blocks or editors.
export const type_code_200 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Large size for code blocks or editors.
export const type_code_300 = {
  fontFamily: 'Roboto Mono, monospace',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // Largest size for code blocks or editors.
export const type_heading_100 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_200 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_300 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_400 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2.5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_500 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3rem',
  lineHeight: '1.16667',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_600 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '3.5rem',
  lineHeight: '1.21429',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_700 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4rem',
  lineHeight: '1.1875',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_800 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '4.5rem',
  lineHeight: '1.22222',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_900 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5rem',
  lineHeight: '1.2',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_heading_1000 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '5.5rem',
  lineHeight: '1.18182',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Description
export const type_body_50 = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for condensed paragraphs, labels, and data display.
export const type_body_100 = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default size for paragraphs, labels, and data display.
export const type_body_200 = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Added prominence for paragraphs, labels, and data display.
export const type_body_300 = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Highest prominence for paragraphs, labels, and data display.
export const type_body_400 = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default size for opening paragraphs in blogs or documentation type of applications.
export const type_body_500 = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
  fontWeight: '400',
}; // A more prominent version for opening paragraphs or quotes in blogs or documentation type of applications.
export const type_body_50_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_50_emphasis_paragraph = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.75rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_100_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_100_emphasis_paragraph = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_200_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_200_emphasis_paragraph = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_300_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_300_emphasis_paragraph = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.125rem',
  lineHeight: '1.55556',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_400_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information.
export const type_body_400_emphasis_paragraph = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0em',
  fontWeight: '600',
}; // Use within paragraphs for bold text.
export const type_body_500_emphasis = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Use within paragraphs for bold text.
export const type_preset_page_title = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '2rem',
  lineHeight: '1.25',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Default text style for page titles.
export const type_preset_page_title_compact = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.5rem',
  lineHeight: '1.33333',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Default text style for page titles in compact page headers.
export const type_preset_section_title = {
  fontFamily:
    'Aeonik,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1.25rem',
  lineHeight: '1.4',
  letterSpacing: '0.02em',
  fontWeight: '500',
}; // Default text style for section titles.
export const type_preset_section_subtitle = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '1rem',
  lineHeight: '1.5',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for section subtitles.
export const type_preset_button = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for buttons and their link variants.
export const type_preset_form_label = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Default text style for form labels.
export const type_preset_form_text = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.875rem',
  lineHeight: '1.57143',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Default text style for forms like input fields and select fields.
export const type_preset_caption = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for smaller captions or labels within components.
export const type_preset_caption_emphasis = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '500',
}; // Use to emphasize or draw attention to certain information within captions.
export const type_preset_menu_item = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.8125rem',
  lineHeight: '1.53846',
  letterSpacing: '0em',
  fontWeight: '400',
}; // Use for links or menu items.
export const type_preset_overline = {
  fontFamily:
    'Inter Var,  -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Helvetica, Arial, sans-serif',
  fontSize: '0.6875rem',
  lineHeight: '1.45455',
  letterSpacing: '0.07em',
  fontWeight: '600',
  textTransform: 'uppercase',
}; // Use for annotations, labels, and statuses.
export const size_layout_app_top = 0; // Pixel value of the top of the app. This is normally 0.
export const size_layout_app_bar_height = 56; // Pixel value of the top of the app. This is normally 0.
export const size_layout_sidebar_width = 265; // Pixel value of the width of the sidebar when open
export const size_layout_sidebar_width_collapsed = 68; // Pixel value of the width of the sidebar when collapsed
